<template>
    <FilterItem
        :add-link
        :disabled
        :label
        :no-icons
        :removable
        :remove-link
        :selected
        :total-results
    >
        <img
            v-if="image"
            :alt="label"
            :src="image"
            loading="lazy"
            class="image"
        />
    </FilterItem>
</template>

<script lang="ts" setup>
import type { ButtonRouteRelative } from '@/components/ui/buttons/useThButton'

import FilterItem from './FilterItem.vue'

defineProps<{
    label: string
    selected?: boolean
    removable?: boolean
    noIcons?: boolean
    image: string | undefined
    addLink?: ButtonRouteRelative
    removeLink?: ButtonRouteRelative
    totalResults: number
    disabled?: boolean
}>()
</script>

<style lang="scss" scoped>
.image {
    --side: 32px;
    width: var(--side);
    height: var(--side);
    object-fit: contain;
}
</style>
